/* QC Beauty — trust-icon USP popups
 * Self-contained. Listens for clicks on the buy-box "icon + text" trust rows
 * (the ai-icon-text-price feature rows) and opens a reusable modal with the
 * matching reassurance copy. No theme markup changes, no dependencies.
 * Store-specific bit: the TRIGGER selector + the DATA object below.
 */
(function () {
  'use strict';

  /* The trust rows in the buy box. Class carries a per-block suffix, so match by prefix. */
  var TRIGGER = '[class*="ai-icon-text-price__feature-"]';

  /* Keyword -> content key. First match wins. */
  function matchKey(text) {
    var t = (text || '').toLowerCase();
    if (/deliver|shipping|freight|postage/.test(t)) return 'delivery';
    if (/return|refund|money.?back/.test(t)) return 'returns';
    if (/warrant/.test(t)) return 'warranty';
    return null;
  }

  var DATA = {
    delivery: {
      title: 'Free Shipping Available',
      body: 'Free standard shipping on every US order of $99 or more. Standard delivery arrives in 4 to 7 business days, fully tracked to your door. Need it sooner? Express delivery lands in 2 to 3 business days for a flat rate at checkout. Orders placed before 12pm PST on a business day usually ship the same day, and you get a tracking link by email the moment it leaves our warehouse.',
      link: '/policies/shipping-policy',
      linkText: 'Read our Shipping Policy →'
    },
    returns: {
      title: '30-Day Returns',
      body: 'Changed your mind? Return any unused product in its original packaging within 30 days of delivery for a full refund. Just email hello@qc-beauty.com with your order number and we will send you a Return Authorisation Number and simple instructions. Refunds are processed within 10 to 14 business days of us receiving your return. If an item arrives faulty or incorrect, we cover the return shipping with a prepaid label.',
      link: '/policies/refund-policy',
      linkText: 'Read our Returns Policy →'
    },
    warranty: {
      title: 'Warranty Protection',
      body: 'Every QC tool is covered against manufacturing faults. To stay protected, buy direct from QC Beauty so your purchase is registered and eligible. You can also add extended protection at checkout for longer peace of mind.',
      link: '/policies/refund-policy',
      linkText: 'Contact us →'
    }
  };

  /* ---- styles (injected once) ---- */
  var CSS = ''
    + '.qc-usp-clickable{cursor:pointer}'
    + '.qc-usp-clickable [class*="ai-icon-text-price__text-"]{text-decoration:none !important;border-bottom:0 !important}'
    + '.qc-usp-clickable:hover{opacity:.72}'
    + '.qc-usp-overlay{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:20px;box-sizing:border-box}'
    + '.qc-usp-overlay.is-open{display:flex}'
    + '.qc-usp-card{position:relative;background:#fff;color:#111;max-width:440px;width:100%;border-radius:10px;padding:28px 26px 26px;box-shadow:0 24px 60px rgba(0,0,0,.28);box-sizing:border-box;max-height:calc(100vh - 40px);overflow:auto;font-family:inherit}'
    + '.qc-usp-card h2{margin:0 6px 12px 0;font-size:20px;line-height:1.25;font-weight:700}'
    + '.qc-usp-card p{margin:0 0 18px;font-size:15px;line-height:1.6}'
    + '.qc-usp-card a.qc-usp-link{display:inline-block;font-size:15px;font-weight:600;color:#111;text-decoration:underline;text-underline-offset:3px}'
    + '.qc-usp-close{position:absolute;top:10px;right:10px;width:34px;height:34px;border:0;background:transparent;font-size:26px;line-height:1;cursor:pointer;color:#111;border-radius:50%}'
    + '.qc-usp-close:hover{background:rgba(0,0,0,.06)}'
    + '@media screen and (max-width:749px){.qc-usp-card{padding:24px 20px 22px}.qc-usp-card h2{font-size:18px}}';

  function injectCSS() {
    if (document.getElementById('qc-usp-style')) return;
    var s = document.createElement('style');
    s.id = 'qc-usp-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- modal (built once, reused) ---- */
  var overlay, card, titleEl, bodyEl, linkEl, lastFocus;

  function buildModal() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'qc-usp-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'qc-usp-title');
    card = document.createElement('div');
    card.className = 'qc-usp-card';
    card.innerHTML =
      '<button type="button" class="qc-usp-close" aria-label="Close">×</button>' +
      '<h2 id="qc-usp-title"></h2>' +
      '<p></p>' +
      '<a class="qc-usp-link" href="#"></a>';
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    titleEl = card.querySelector('h2');
    bodyEl = card.querySelector('p');
    linkEl = card.querySelector('a.qc-usp-link');

    card.querySelector('.qc-usp-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  function open(key) {
    var d = DATA[key];
    if (!d) return;
    buildModal();
    titleEl.textContent = d.title;
    bodyEl.textContent = d.body;
    if (d.link) {
      linkEl.style.display = '';
      linkEl.setAttribute('href', d.link);
      linkEl.textContent = d.linkText || 'Learn more →';
    } else {
      linkEl.style.display = 'none';
    }
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    card.querySelector('.qc-usp-close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- mark matched rows as interactive (cursor + a11y) ---- */
  function markRows() {
    var rows = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute('data-qc-usp')) continue;
      var key = matchKey(row.textContent);
      if (!key) continue;
      row.setAttribute('data-qc-usp', key);
      row.classList.add('qc-usp-clickable');
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
    }
  }

  /* ---- event delegation ---- */
  function onActivate(e) {
    var row = e.target.closest ? e.target.closest(TRIGGER) : null;
    if (!row) return;
    var key = row.getAttribute('data-qc-usp') || matchKey(row.textContent);
    if (!key || !DATA[key]) return;
    e.preventDefault();
    e.stopPropagation();
    open(key);
  }

  function init() {
    injectCSS();
    markRows();
    document.addEventListener('click', onActivate, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var row = e.target.closest ? e.target.closest(TRIGGER) : null;
      if (row && row.getAttribute('data-qc-usp')) onActivate(e);
    }, true);
    /* re-mark if the buy box re-renders (variant switch, ajax) */
    if (window.MutationObserver) {
      new MutationObserver(function () { markRows(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
